<template>
  <b-form style="height: 30rem" @submit.prevent="submit">
    <b-row>
      <b-col md="12">
        <b-form-group label="Datum *">
          <date-picker name="date" v-model="nviData.date"/>
          <app-validation-description :show="$v.nviData.date.$dirty && $v.nviData.date.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="12" >
        <b-form-group label="Vrijednost *">
          <app-decimal-input  :decimals="4"  v-model="nviData.value"/>
          <app-validation-description :show="$v.nviData.value.$dirty && $v.nviData.value.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>

    </b-row>
    <b-row class="mb-3">
      <b-col>
        <submit :loading="loading"></submit>
      </b-col>
      <b-col v-if="nviObject && nviObject.id">
        <delete-button
          @click="showDeleteDialog=true"
          class="pull-right">
        </delete-button>

        <confirmation-dialog :show="showDeleteDialog" @confirm="deleteApp" @cancel="showDeleteDialog=false"> </confirmation-dialog>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Submit from '@/components/app/AppSubmit'
import DatePicker from '@/components/app/datetime/DatePicker'
import AppValidationDescription from "@/components/app/form/AppValidationDescription";
import { required } from 'vuelidate/lib/validators'
import {toast} from "@/shared/plugins/toastr";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
import {createNvi, deleteNvi, updateNvi} from "@/services/nvi";
import {cloneDeep} from "lodash";
import ConfirmationDialog from '@/components/app/form/AppConfirmationDialog'
import DeleteButton from '@/components/app/AppDelete'
import {deleteUser} from "@/services/user";
import AppDecimalInput from "@/components/app/AppDecimalInput";

export default {
  name: 'NviForm',
  props: {
    nviObject: {
      type: Object
    }
  },
  data() {
    return {
      nviData: {
        date: null,
        value: null
      },
      loading: false,
      showDeleteDialog: false
    };
  },
  components: {
    AppDecimalInput,
    AppValidationDescription,
    Submit,
    DatePicker,
    ConfirmationDialog,
    DeleteButton
  },
  mixins:[getErrorMessage],
  validations:{
    nviData:{
      date: { required },
      value: { required },
    }
  },
  methods: {
    deleteApp(){
      deleteNvi(this.nviData.id)
        .then(() => {
          this.showDeleteDialog = false,
            toast({
              'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
          this.$emit('success')
        },error => {
          toast({
            'title': "Greska",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        })
    },
    submit() {
      this.$v.nviData.$touch()
      if(this.$v.nviData.$invalid){
        toast({
          'title': this.$t('VALIDATION_FAILED'),
          'message': null,
          'type': 'error',
          'timeout': 6000
        })
        return
      }
      this.loading = true;
      if(this.nviData.id) {
        updateNvi(this.nviData.id, this.nviData).then(() => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$emit('success')
        }, (error) => {
          toast({
            'title': "Save  fail",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=> {
          this.loading = false;
        })
      } else {
        createNvi(this.nviData).then(() => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$emit('success')
        }, (error) => {
          toast({
            'title': "Save  fail",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=> {
          this.loading = false;
        })
      }
    }
  },
  created() {
    if(this.nviObject) {
      this.nviData = cloneDeep(this.nviObject);
    }
  }
};
</script>

<style scoped>

</style>
